import { Component } from '@angular/core';

@Component({
  selector: 'icon-info',
  templateUrl: './icon-info.component.html',
  styleUrls: ['./icon-info.component.sass']
})
export class IconInfoComponent {}
